import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type JoinJiraDetailsFragment = (
  { __typename: 'Organization' }
  & Pick<Types.Organization, 'id' | 'creationMethod'>
);

export const JoinJiraDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JoinJiraDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Organization' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creationMethod' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseJoinJiraDetailsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      JoinJiraDetailsFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseJoinJiraDetailsFragmentResult
  extends Omit<Apollo.UseFragmentResult<JoinJiraDetailsFragment>, 'data'> {
  data?: JoinJiraDetailsFragment;
}

export const useJoinJiraDetailsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseJoinJiraDetailsFragmentOptions): UseJoinJiraDetailsFragmentResult => {
  const result = Apollo.useFragment<JoinJiraDetailsFragment>({
    ...options,
    fragment: JoinJiraDetailsFragmentDoc,
    fragmentName: 'JoinJiraDetails',
    from: {
      __typename: 'Organization',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as JoinJiraDetailsFragment };
};
